// SelectedSignalBrief — full-width detail card for the Workbench preview.
//
// We deliberately reuse the existing `MarketTrackDetailPanel` rather than
// reimplementing every section: that panel already covers all six bullets
// from the user brief (Header / Strategic read / Pattern structure /
// Current evidence / Weekly dynamics / Structural footprint), uses the
// governed-signal feature detection, and renders the cleaned-up chip row.
//
// The workbench wrapper just changes the framing (full-width banner +
// "Selected signal brief" eyebrow) and keeps everything else identical, so
// any future polish to the detail panel automatically flows into the
// workbench preview too.

import React from "react";
import MarketTrackDetailPanel from "../dashboard/MarketTrackDetailPanel";

const SelectedSignalBrief = ({ track, history, allTracks, onSelectTrack }) => {
    if (!track) {
        return (
            <div className="card-flat p-6 text-sm text-[hsl(var(--mute))] text-center" data-testid="workbench-signal-brief-empty">
                Select a signal in the table above to see its full brief here.
            </div>
        );
    }
    return (
        <section data-testid="workbench-signal-brief">
            <div className="eyebrow mb-2">Selected signal brief</div>
            <MarketTrackDetailPanel
                track={track}
                history={history}
                allTracks={allTracks}
                onSelectTrack={onSelectTrack}
            />
        </section>
    );
};

export default SelectedSignalBrief;
